import { useSelector } from 'react-redux';
import { useEffect } from 'react';

import { posSendMessage } from 'utils/hooks/useWrapper';
import { getWrapperData } from 'reducers/wrapper';

const wrapperData: Record<string, any> = {};
// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
window.wrapperData = wrapperData;

export const useWrapperContextVariables = () => {
  const newWrapperData = useSelector(getWrapperData);
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    window.wrapperData = newWrapperData;
    // @ts-ignore
    posSendMessage('meta:wrapperDataChanged')(newWrapperData);
  }, [JSON.stringify(newWrapperData)])

};
